import creditCardIcon from "assets/credit_card.svg";
import FormInput from "components/FormInput/FormInput";
import FormMultiFileInput from "components/FormMultiFileInput/FormMultiFileInput";
import FormToggleButtonGroup from "components/FormToggleButtonGroup/FormToggleButtonGroup";
import { Card, Col, Container, Row } from "react-bootstrap";
import { DatePicker } from "shared/ui";

function StatementUploadFormView({
  creditCardTypes = [],
  allowedFilesTypes = [],
  maxAllowedFileSize,
  cardFormat = "us/ca",
  children = null,
  requestor,
}) {
  return (
    <Container className="text-start py-5 px-0" style={{ minHeight: "auto" }}>
      <Card className="px-5 py-5">
        <Row>
          <Col md>
            <img
              src={creditCardIcon}
              style={{
                height: "35px",
                display: "inline",
              }}
              alt="cost icon"
            />
            <h1 className="fs-3 mt-3">
              {cardFormat === "us/ca" && "Card request"}
              {cardFormat === "corporate" && "Corporate Cards request"}
            </h1>
          </Col>
          {cardFormat === "us/ca" && (
            <Col md>
              Request for: <br />
              <strong>{requestor}</strong>
            </Col>
          )}
        </Row>
        <div className="border-top my-4"></div>
        <Row className="mt-3">
          {cardFormat === "corporate" && (
            <FormInput
              name="company_code"
              label="State company code"
              text="(selected from top bar menu)"
              displayAs={Col}
              readOnly
            />
          )}
          <FormMultiFileInput
            name="file"
            acceptedExtensions={allowedFilesTypes
              .map((ext) => `.${ext}`)
              .join(", ")}
            maxAllowedFileSize={maxAllowedFileSize}
          />
          <FormToggleButtonGroup
            name="card_type"
            options={creditCardTypes}
            label="Card type"
            displayAs={Col}
          />
        </Row>{" "}
        {cardFormat !== "corporate" && (
          <Row className="mt-3">
            <DatePicker label="Date start" name="date_start" displayAs={Col} />
            <DatePicker label="Date end" name="date_end" displayAs={Col} />
          </Row>
        )}
        {cardFormat === "us/ca" && (
          <Row className="mt-3">
            <FormInput
              name="company_code"
              label="State company code"
              text="(must be 4 characters)"
              displayAs={Col}
            />
            <FormInput
              name="additional_info"
              label="State additional info"
              text="(max. 10 characters, optional)"
              displayAs={Col}
            />
          </Row>
        )}
        {children}
      </Card>
    </Container>
  );
}

export default StatementUploadFormView;
